module.exports = __webpack_public_path__ + "static/media/sms.d4086d7e.svg";